import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import BrandDialog from './BrandDialog';
import BrandDragDrop from './BrandDragDrop';

import { categoriesLoad } from '../../../../actions/category';
import { simpleConfirmDialog } from '../../../../actions/swal_msg';
import { deleteBrands, updateBrands } from '../../../../actions/admin/product/product_brand';

import {
    Button, Typography, Alert, Fab, Container, Box
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import AddIcon from '@mui/icons-material/Add';
import UpdateIcon from '@mui/icons-material/Update';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

const BrandContainer = () => {
    const dispatch = useDispatch();

    // marcas de producto
    const { brands: allBrands } = useSelector(state => state.category);

    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [changed, setChanged] = useState(false);

    const [brands, setBrands] = useState([]);
    const [brandsBackup, setBrandsBackup] = useState([]);

    useEffect(() => {
        dispatch(categoriesLoad()); // categorías y marcas de producto
    }, []);

    useEffect(() => {
        const obj = allBrands.map(e => ({ ...e, checked: false }));
        setBrands(obj);
        setBrandsBackup(obj);
    }, [allBrands]);

    useEffect(() => {
        // lógica para identificar algún cambio en las marcas
        if (JSON.stringify(brandsBackup) === JSON.stringify(brands))
            setChanged(false);
        else setChanged(true);
    }, [brands]);

    const deleteMultipleBrands = async () => {
        if (await simpleConfirmDialog('¿Eliminar marcas seleccionadas?', 'Sí, continuar')) {
            setLoading(true);
            dispatch(deleteBrands(brands.filter(e => e.checked), setLoading));
        }
    };

    const updateBrandsFn = () => {
        setLoading(true);
        dispatch(updateBrands(brands, setLoading));
    };

    return (
        <Container maxWidth='xxl' sx={{ mb: 5, mt: 12 }}>

            <Box
                mb={3}
                sx={{
                    display: 'flex',
                    justifyContent: "flex-start",
                    flexWrap: 'wrap',
                    gap: '20px',
                    alignItems: "flex-start"
                }}>
                <Typography variant="h5" gutterBottom sx={{ my: 'auto' }}>
                    Marcas de producto
                </Typography>
                <Button variant="outlined" sx={{ textTransform: 'none', my: 'auto' }}
                    endIcon={
                        <AddIcon fontSize="inherit" />
                    } onClick={() => setOpen(true)}>
                    Agregar
                </Button>
            </Box>

            {
                brands.filter(e => e.checked).length > 0 &&
                <LoadingButton
                    sx={{ mb: 3 }}
                    endIcon={<DeleteForeverIcon />}
                    loading={loading}
                    loadingPosition="end"
                    variant="contained"
                    onClick={deleteMultipleBrands}>
                    Eliminar marcas seleccionadas
                </LoadingButton>
            }

            {
                allBrands.length > 0 ?
                    <BrandDragDrop
                        brands={brands}
                        setBrands={setBrands}
                    />
                :
                    <Alert severity="info">No hay marcas registradas.</Alert>
            }

            <BrandDialog
                open={open}
                setOpen={setOpen}
            />
            {
                changed &&
                    <Fab color="primary"
                        aria-label="update" sx={{
                            position: "fixed",
                            bottom: (theme) => theme.spacing(2),
                            right: (theme) => theme.spacing(2)
                        }}
                        disabled={loading}
                        onClick={updateBrandsFn}>
                        <UpdateIcon />
                    </Fab>
            }
        </Container>
    );
};

export default BrandContainer;